import useMutation from "src/hooks/useMutation";

function useEmployeeRemove(id) {
  return useMutation({
    path: `/api/v1/users/${id}`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/users`,
      shouldRevalidate: true,
    },
  });
}

export default useEmployeeRemove;
